module.exports = __webpack_public_path__ + "img/Noelle Leslie dela Cruz.7d24f38f.jpg";